import { render, staticRenderFns } from "./DOIInformation.vue?vue&type=template&id=3e4b25b1"
import script from "./DOIInformation.vue?vue&type=script&lang=js"
export * from "./DOIInformation.vue?vue&type=script&lang=js"
import style0 from "./DOIInformation.vue?vue&type=style&index=0&id=3e4b25b1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports